import { SET_DATA_ORDER_FOR_SHOW_AND_EDIT, SET_DELIVERY_POINT_LIST, SET_FILTER_DELIVERY_DATE, SET_FILTER_DISPATCH_DATE, SET_FILTER_ORDER_TEXT, SET_FILTER_ROUTE, SET_INFORMATION_DELIVERY, SET_LIST_OF_PRODUCTS_FOR_BEGING_ORDER, SET_MESSAGE_ORDERS_REQUESTED, SET_MESSAGE_SAVE_ORDER_STATE, SET_ORDER_INFO_TO_ADD_NEW_PRODUCT_IN, SET_SELECT_CLIENT, SET_SELECT_DELIVERY_DATE, SET_SELECT_DELIVERY_POINT } from 'orden_express/orders/ordersActions.js';
import { REQUEST_RESET_STATE_ORDER, RESPONSE_GET_DELIVERY_DATES, RESPONSE_GET_ORDERS_REQUESTED, RESPONSE_GET_ORDER_REQUESTED_DETAIL, RESPONSE_SAVE_ORDER_BEGINING, RESPONSE_SAVE_ORDER_PRODUCT_DETAIL, RESPONSE_SEND_EMAIL_ORDER, RESPONSE_SAVE_ORDER_STATE, RESPONSE_DELETE_ORDER } from 'orden_express/orders/ordersEpic.js';


const initialState = {
   listOfProductsForBeginingOrder: [],
   responseSaveOrderBegining: {},
   responseGetDeliveryDates: {},
   selectDeliveryDate: { value: '', lable: '' },
   selectDeliveryPoint: { value: '', lable: '' },
   selectClient: { value: '', lable: '' },
   informationDelivery: '',
   messageSaveOrderState: 0,
   responseGetOrdersRequested: {},
   filterRoute: { value: '', label: 'Todos' },
   responseGetDetailOrderRequested: {},
   responseSaveOrderProductDetail: {},
   setDeliveryPointList: [],
   filterDispatchDate: '',
   filterDeliveryDate: '',
   filterOrderText: '',
};

const ordersReducer = (state = initialState, action) => {
   switch (action.type) {

      case REQUEST_RESET_STATE_ORDER:
         return {
            ...state,
            listOfProductsForBeginingOrder: [],
            responseSaveOrderBegining: {},
            responseGetDeliveryDates: {},
            selectDeliveryDate: { value: '', lable: '' },
            selectDeliveryPoint: { value: '', lable: '' },
            selectClient: { value: '', lable: '' },
            informationDelivery: '',
            messageSaveOrderState: 0,
            responseGetOrdersRequested: {},
            filterRoute: { value: '', label: 'Todos' },
            responseGetDetailOrderRequested: {},
            responseSaveOrderProductDetail: {},
            setDeliveryPointList: [],
            filterDispatchDate: '',
            filterDeliveryDate: '',
            filterOrderText: '',
         };

      case SET_FILTER_ORDER_TEXT:
         return {
            ...state,
            filterOrderText: action.filterOrderText
         }

      case SET_FILTER_DELIVERY_DATE:
         return {
            ...state,
            filterDeliveryDate: action.filterDeliveryDate
         }

      case SET_FILTER_DISPATCH_DATE:
         return {
            ...state,
            filterDispatchDate: action.filterDispatchDate
         }

      case SET_DELIVERY_POINT_LIST:
         return {
            ...state,
            setDeliveryPointList: action.setDeliveryPointList,
         };

      case SET_ORDER_INFO_TO_ADD_NEW_PRODUCT_IN:
         return {
            ...state,
            dataOrderInfoToAddNewProductIn: action.dataOrderInfoToAddNewProductIn,
         };

      case RESPONSE_SAVE_ORDER_PRODUCT_DETAIL:
         return {
            ...state,
            responseSaveOrderProductDetail: action.responseSaveOrderProductDetail,
            messageOrdersRequested: action.responseSaveOrderProductDetail.errorState === true ? 3 : 2
         };

      case RESPONSE_GET_ORDER_REQUESTED_DETAIL:
         return {
            ...state,
            responseGetOrderRequestedDetail: action.responseGetOrderRequestedDetail,
            messageOrdersRequested: action.responseGetOrderRequestedDetail.errorState === true ? 3 : 2
         };

      case SET_DATA_ORDER_FOR_SHOW_AND_EDIT:
         return {
            ...state,
            dataOrderForShowAndEdit: action.dataOrderForShowAndEdit
         };

      case SET_FILTER_ROUTE:
         return {
            ...state,
            filterRoute: action.filterRoute
         };

      case SET_MESSAGE_ORDERS_REQUESTED:
         return {
            ...state,
            messageOrdersRequested: action.messageOrdersRequested
         };
      //es la generalización del RESPONSE_GET_ORDERS_REQUESTED
      case RESPONSE_SAVE_ORDER_STATE:
         return {
            ...state,
            responseGetOrdersRequested: action.responseSaveOrderState,
            messageOrdersRequested: action.responseSaveOrderState.errorState === true ? 3 : 2
         };

      //Se conecta con RESPONSE_SAVE_ORDER_STATE
      case RESPONSE_GET_ORDERS_REQUESTED:
         return {
            ...state,
            responseGetOrdersRequested: action.responseGetOrdersRequested,
            messageOrdersRequested: action.responseGetOrdersRequested.errorState === true ? 3 : 2
         };

      case SET_MESSAGE_SAVE_ORDER_STATE:
         return {
            ...state,
            messageSaveOrderState: action.messageSaveOrderState
         };

      case SET_INFORMATION_DELIVERY:
         return {
            ...state,
            informationDelivery: action.informationDelivery
         };

      case SET_SELECT_DELIVERY_DATE:
         return {
            ...state,
            selectDeliveryDate: action.selectDeliveryDate
         };

      case SET_SELECT_DELIVERY_POINT:
         return {
            ...state,
            selectDeliveryPoint: action.selectDeliveryPoint
         };

      case SET_SELECT_CLIENT:
         return {
            ...state,
            selectClient: action.selectClient
         };

      case RESPONSE_GET_DELIVERY_DATES:
         var defaultValue = { value: '', label: '' };
         try {
            var found = false;
            var list = action.responseGetDeliveryDates.result;
            defaultValue = { value: list[0].timeStamp, label: list[0].deliveryDate };
            var pos = 0;
            var length = list.length;
            while (pos < length) {
               var itemDeliveryDate = list[pos];
               var localvalue = { value: itemDeliveryDate.timeStamp, label: itemDeliveryDate.deliveryDate }
               if (localvalue === state.selectDeliveryDate) {
                  found = true;
               }
               pos++;
            }
            /*list.map((itemDeliveryDate)=>{
               var localvalue={ value: itemDeliveryDate.timeStamp, label: itemDeliveryDate.deliveryDate }
               if(localvalue===state.selectDeliveryDate){
                  found=true;
               }
            })*/
         } catch (__) { }

         return {
            ...state,
            responseGetDeliveryDates: action.responseGetDeliveryDates,
            selectDeliveryDate: found === true ? state.selectDeliveryDate : defaultValue,
            //{ value: itemDeliveryDate.timeStamp, label: itemDeliveryDate.deliveryDate }
         };

      case SET_LIST_OF_PRODUCTS_FOR_BEGING_ORDER:
         return {
            ...state,
            listOfProductsForBeginingOrder: action.listOfProductsForBeginingOrder
         };

      case RESPONSE_SAVE_ORDER_BEGINING:
         if (action.responseSaveOrderBegining.errorState === true) {
            return {
               ...state,
               responseSaveOrderBegining: action.responseSaveOrderBegining,
               messageSaveOrderState: 3
            };
         } else {
            return {
               ...state,
               responseSaveOrderBegining: action.responseSaveOrderBegining,
               messageSaveOrderState: 2
            };
         }

      case RESPONSE_SEND_EMAIL_ORDER:
         return {
            ...state,
            messageOrdersRequested: 2
         };

      case RESPONSE_DELETE_ORDER:
         return {
            ...state,
            responseGetOrdersRequested: action.responseDeleteOrder,
            messageOrdersRequested: 2
         };

      default:
         return state;
   }
}

export default ordersReducer;